import React, { useEffect, useState } from "react"; 
import "./campoasistido.css";


const CAMPOS_CON_PLANTILLAS = new Set([
  // Heredofamiliares
  "heredofamiliares_consolidado",
  "heredofamiliares_madre",
  "heredofamiliares_padre",
  "heredofamiliares_hermanos",
  "heredofamiliares_abuelos",
  "heredofamiliares_otros",

  // Personales no patológicos
  "no_patologicos_consolidado",
  "no_patologicos_origen",
  "no_patologicos_ocupacion",
  "no_patologicos_escolaridad",
  "no_patologicos_religion",
  "no_patologicos_mascotas",
  "no_patologicos_viajes",
  "no_patologicos_alimentacion",
  "no_patologicos_vivienda",
  "no_patologicos_otros",

  // Personales patológicos
  "patologicos_ECD",
  "patologicos_alergias",
  "patologicos_consolidado",
  "patologicos_quirurgicos",
  "patologicos_traumaticos",
  "patologicos_hospitalizaciones",
  "patologicos_infectocontagiosos",
  "patologicos_transfusionales",
  "patologicos_exantematicos",
  "patologicos_alcohol",
  "patologicos_tabaco",
  "patologicos_toxicomanias",
  "patologicos_vacunacion",
  "patologicos_ginecoObstetricosAndrologicos",
  "patologicos_otros",

  // Exploracion, Pronóstico y plan
  "exploracion_fisica",
  "pronostico",
  "planTratamiento",
  

  // Interrogatorio por aparatos y sistemas
   "interrogatorio_consolidado",
   "sistema_nervioso",
   "sistema_cardiovascular",
   "sistema_respiratorio",
   "sistema_digestivo",
   "sistema_genitourinario",
   "sistema_musculoesqueletico",
   "sistema_endocrino",
   "sistema_hematologico",
   "piel_anexos",
 ]);


const escaparRegex = (texto) => {
  return String(texto).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};


const contienePalabraClave = (valorActual, palabraClave) => {
  const valor = String(valorActual || "");
  const clave = String(palabraClave || "").trim();

  if (!clave) return false;

  const regex = new RegExp(
    `\\b${escaparRegex(clave)}\\b`,
    "i"
  );

  return regex.test(valor);
};


/*
 * Devuelve la plantilla correspondiente al campo
 * únicamente cuando cumple todas las condiciones.
 */
export const obtenerSugerenciaPlantilla = ({
  campo,
  valorActual,
  plantillasHabilitadas,
  plantillasPersonalizadas,
}) => {
  if (!plantillasHabilitadas) return null;

  if (!CAMPOS_CON_PLANTILLAS.has(campo)) return null;

  if (!Array.isArray(plantillasPersonalizadas)) return null;

  const plantilla = plantillasPersonalizadas.find((item) => {
    if (!item) return false;

    if (item.campo !== campo) return false;

    if (item.habilitada === false) return false;

    const palabraClave = String(
      item.palabra_clave || ""
    ).trim();

    const texto = String(
      item.texto || ""
    ).trim();

    if (!palabraClave || !texto) return false;

    return contienePalabraClave(
      valorActual,
      palabraClave
    );
  });

  return plantilla || null;
};


/*
 * Sustituye solamente la primera aparición
 * de la palabra clave por el texto de la plantilla.
 */
export const aplicarSugerenciaPlantilla = ({
  valorActual,
  plantilla,
}) => {
  const valor = String(valorActual || "");

  if (!plantilla) return valor;

  const palabraClave = String(
    plantilla.palabra_clave || ""
  ).trim();

  const texto = String(
    plantilla.texto || ""
  ).trim();

  if (!palabraClave || !texto) return valor;

  const regex = new RegExp(
    `\\b${escaparRegex(palabraClave)}\\b`,
    "i"
  );

  return valor.replace(regex, texto);
};


/*
 * Campo reutilizable con asistencia por plantilla.
 *
 * El formulario dueño del estado sigue controlando:
 * - value
 * - onChange
 * - actualización final mediante onAplicar
 */
export default function CampoAsistido({
  tipo = "input",
  campo,
  name,
  value = "",
  placeholder = "",
  onChange,
  onAplicar,

  plantillasHabilitadas = false,
  plantillasPersonalizadas = [],

  sugerenciasHistoricasHabilitadas = true,
  buscarSugerenciasHistoricas = null,
  onOcultarSugerenciaHistorica = null,

  autoComplete = "off",

  onFocus,
  onBlur,
  onKeyDown,

  ...rest
}) {
  const [campoActivo, setCampoActivo] = useState(false);
  const [sugerenciasHistoricas, setSugerenciasHistoricas] = useState([]);

  const sugerencia = obtenerSugerenciaPlantilla({
    campo,
    valorActual: value,
    plantillasHabilitadas,
    plantillasPersonalizadas,
  });

    useEffect(() => {
    const texto = String(value || "").trim();

    if (
      !sugerenciasHistoricasHabilitadas ||
      typeof buscarSugerenciasHistoricas !== "function" ||
      texto.length < 3
    ) {
      setSugerenciasHistoricas([]);
      return;
    }

    const timer = setTimeout(async () => {
      const resultados = await buscarSugerenciasHistoricas(campo, texto);

      setSugerenciasHistoricas(
        Array.isArray(resultados) ? resultados.slice(0, 3) : []
      );
    }, 300);

    return () => clearTimeout(timer);
  }, [
    value,
    campo,
    sugerenciasHistoricasHabilitadas,
    buscarSugerenciasHistoricas,
  ]);

  const mostrarSugerencia =
    campoActivo &&
    sugerencia !== null;


  const aplicarPlantilla = () => {
    if (!sugerencia) return;

    const nuevoValor = aplicarSugerenciaPlantilla({
      valorActual: value,
      plantilla: sugerencia,
    });

    if (typeof onAplicar === "function") {
        onAplicar(nuevoValor, sugerencia);
        } else if (typeof onChange === "function") {
        onChange({
            target: {
            name: name || campo,
            value: nuevoValor,
            },
        });
        }

        setCampoActivo(false);
  };

    const aplicarHistorico = (historico) => {
    const nuevoValor = String(historico?.valor || "").trim();

    if (!nuevoValor) return;

    if (typeof onAplicar === "function") {
      onAplicar(nuevoValor, historico);
    } else if (typeof onChange === "function") {
      onChange({
        target: {
          name: name || campo,
          value: nuevoValor,
        },
      });
    }

    setSugerenciasHistoricas([]);
    setCampoActivo(false);
  };

   const ocultarHistorico = async (historico) => {
    const valor = String(historico?.valor || "").trim();

    if (!valor) return;

    if (typeof onOcultarSugerenciaHistorica === "function") {
      await onOcultarSugerenciaHistorica(campo, valor);
    }

    setSugerenciasHistoricas((prev) =>
      prev.filter((item) => item?.valor !== historico?.valor)
    );

    setCampoActivo(true);
  };

  const manejarFocus = (e) => {
    setCampoActivo(true);

    if (typeof onFocus === "function") {
      onFocus(e);
    }
  };


  const manejarBlur = (e) => {
    setCampoActivo(false);

    if (typeof onBlur === "function") {
      onBlur(e);
    }
  };


  const manejarChange = (e) => {
    setCampoActivo(true);

    if (typeof onChange === "function") {
      onChange(e);
    }
  };


 const manejarKeyDown = (e) => {
  if (e.key === "Enter" && !e.shiftKey) {
    if (mostrarSugerencia) {
      e.preventDefault();
      aplicarPlantilla();
      return;
    }

    if (campoActivo && sugerenciasHistoricas.length > 0) {
      e.preventDefault();
      aplicarHistorico(sugerenciasHistoricas[0]);
      return;
    }
  }

  if (typeof onKeyDown === "function") {
    onKeyDown(e);
  }
};


  const propiedadesCampo = {
    ...rest,

    name: name || campo,
    value: value ?? "",
    placeholder,
    autoComplete,

    onFocus: manejarFocus,
    onBlur: manejarBlur,
    onChange: manejarChange,
    onKeyDown: manejarKeyDown,
  };


  return (
  <div className="campo-asistido">
    {tipo === "textarea" ? (
      <textarea {...propiedadesCampo} />
    ) : (
      <input
        type="text"
        {...propiedadesCampo}
      />
    )}

    {mostrarSugerencia && (
      <div
        className="campo-asistido__dropdown"
        role="listbox"
      >
        <div
          className="campo-asistido__opcion"
          role="option"
          aria-selected="false"
          onMouseDown={(e) => {
            e.preventDefault();
            aplicarPlantilla();
          }}
        >
          <div className="campo-asistido__encabezado">
            <span className="campo-asistido__etiqueta">
              PLANTILLA GUARDADA
            </span>

            <span className="campo-asistido__ayuda">
              Enter para insertar
            </span>
          </div>

          <div className="campo-asistido__texto">
            {sugerencia.texto}
          </div>
        </div>
      </div>
    )}
        {campoActivo && sugerenciasHistoricas.length > 0 && (
      <div
        className="campo-asistido__dropdown"
        role="listbox"
      >
        {sugerenciasHistoricas.map((historico) => (
          <div
            key={`${historico.valor}-${historico.usos}`}
            className="campo-asistido__opcion"
            role="option"
            aria-selected="false"
            onMouseDown={(e) => {
              e.preventDefault();
              aplicarHistorico(historico);
            }}
          >
                       <div className="campo-asistido__encabezado">
              <span className="campo-asistido__etiqueta">
                USADO ANTERIORMENTE
              </span>

              <span className="campo-asistido__ayuda">
                {historico.usos} usos
              </span>

            {typeof onOcultarSugerenciaHistorica === "function" && (
              <span
                className="campo-asistido__ocultar"
                title="Ocultar esta opción"
                role="button"
                tabIndex={0}
                aria-label={`Ocultar esta opción: ${historico.valor}`}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  ocultarHistorico(historico);
                }}
              >
                <span
                  className="campo-asistido__ocultar-circulo"
                  aria-hidden="true"
                >
                  ×
                </span>

                <span className="campo-asistido__ocultar-texto">
                  No mostrar
                </span>
              </span>
            )}
            </div>

            <div className="campo-asistido__texto">
              {historico.valor}
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);
}